<div class="chat-interface" *ngIf="false">
    @if (progressService.isUploading()) {
        <div class="upload-status">
            <div class="upload-status__content">
                <div class="upload-status__spinner"></div>
                <span class="upload-status__text">
                    {{ progressService.feedbackMessage() }}
                </span>
            </div>

            @if (progressService.showActions()) {
                <div class="upload-status__actions">
                    <button class="btn-link" (click)="onKeepWaiting()">Keep waiting</button>
                    <span class="separator">•</span>
                    <button class="btn-link" (click)="onCancelUpload()">Cancel</button>
                    <span class="separator">•</span>
                    <button class="btn-link" (click)="onUploadDifferent()">
                        Upload different file
                    </button>
                </div>
            }
        </div>
    }
</div>
<div
    class="search-input-container"
    [ngClass]="{ 'search-input-container__read-only': readOnlyInput }"
>
    <div class="input-group">
        <div class="input-group__textarea__container" [ngClass]="{ 'page-scroll': hasPageScroll }">
            <textarea
                class="input-group__textarea"
                [attr.placeholder]="placeholder"
                [disabled]="disabled"
                [rows]="textareaRows"
                [class.input-group__textarea--scrollable]="textareaHasOverflow"
                (input)="setTextareaRows()"
                (keydown.enter)="
                    !(
                        loaderService.currentSendButtonDisabledFlag() ||
                        !textareaText ||
                        textareaText.trim().length === 0
                    ) && chat($event)
                "
                [(ngModel)]="textareaText"
                [ngClass]="{
                    'input-group__textarea__textActive':
                        textareaText && textareaText.trim().length > 0,
                }"
                #chatInput
            ></textarea>

            <mapp-search-input-files
                *ngIf="fileStateService.showConversationFiles() && files?.length"
                class="input-group__files"
                [files]="files"
                (delete)="handleDeleteFile($event)"
            ></mapp-search-input-files>
        </div>
        <div class="input-group__actions">
            <img
                *ngIf="canShowAttachmentIcon()"
                (click)="selectFile()"
                class="attachment-icon"
                [ngClass]="{ 'img-disabled': progressService.attachmentDisabled() }"
                [src]="
                    disabled || progressService.attachmentDisabled()
                        ? '/assets/icons/upload-disabled.svg'
                        : '/assets/icons/upload-enabled.svg'
                "
                alt="Upload"
                [aidaTooltip]="
                    progressService.attachmentDisabled()
                        ? 'File upload in progress!'
                        : fileUploadConfig.tooltipMessage
                "
                aidaTooltipPosition="top"
                [aidaTooltipDisabled]="disabled"
            />
            <img
                [ngClass]="{
                    'img-disabled':
                        loaderService.currentSendButtonDisabledFlag() ||
                        !textareaText ||
                        textareaText.trim().length === 0,
                }"
                (click)="chat($event)"
                [src]="
                    disabled ||
                    disableSubmit ||
                    loaderService.currentSendButtonDisabledFlag() ||
                    !textareaText ||
                    textareaText.trim().length === 0
                        ? '/assets/icons/send-grey.svg'
                        : '/assets/icons/send.svg'
                "
                alt="Send"
            />
        </div>
    </div>
</div>
<mapp-action-modal
    #fileWarningModal
    [iconPath]="'/assets/icons/warning-blue.svg'"
    [title]="fileWarningTitle"
    [description]="fileWarningMessage"
></mapp-action-modal>
<mapp-action-modal
    #fileModal
    modalClass="action-modal--file-save"
    [title]="titleFileModal"
    [description]="bodyFileModal"
    [primaryButton]="primaryButtonFileObject"
    [secondaryNoButton]="secondaryNoButtonFileObject"
    (closeModal)="closeFileUploadModal()"
></mapp-action-modal>
